module.exports = __webpack_public_path__ + "img/bg-3@1000x-80-min.15772815.webp";